import { ReactNode } from 'react';
import { Button, Container, Link, Stack, Typography } from '@krakentech/coral';
import { IconCircleExclamationFilled } from '@krakentech/icons';

import { AuthenticatedPageLayout, FormContainer } from '@/components';
import PIITypography from '@/components/PII/PIITypography';
import { useDisabledFFRedirect } from '@/hooks/utils/useDisabledFFRedirect';
import { FeatureNames } from '@/types/features';
import { INTERNAL_PATHS } from '@/utils/urls';

const CheckMeterStop = () => {
  useDisabledFFRedirect({
    featureFlag: FeatureNames.ApplyForMeter,
    redirectPath: INTERNAL_PATHS.HOME.path,
  });

  return (
    <Container component="section" paddingX="md" paddingY="xxxl">
      <FormContainer>
        <Stack gap="lg" direction="vertical" alignItems="center">
          <Stack gap="smMd" direction="vertical" alignItems="center">
            <IconCircleExclamationFilled size={72} />
            <Stack gap="xsSm" direction="vertical">
              <Typography variant="h2" textAlign="center">
                We&apos;ve already installed a water meter outside your home
              </Typography>
              <PIITypography>
                We use it to help us manage our water network and check for
                leaks. However, you&apos;re currently not being charged based on
                this meter.
              </PIITypography>
              <PIITypography>
                If you&apos;d like to switch to being billed on a meter and only
                pay for what you use, please{' '}
                <Link
                  href={process.env.NEXT_PUBLIC_HELP_LINK as string}
                  target="_blank"
                >
                  get in touch
                </Link>{' '}
                and one of our team can help get you set up.
              </PIITypography>
            </Stack>
          </Stack>
          <Button href={INTERNAL_PATHS.HOME.path} fullWidth size="medium">
            Finish
          </Button>
        </Stack>
      </FormContainer>
    </Container>
  );
};

CheckMeterStop.getLayout = (page: ReactNode) => (
  <AuthenticatedPageLayout
    pageTitle={INTERNAL_PATHS.APPLY_FOR_METER_STOP.title}
  >
    {page}
  </AuthenticatedPageLayout>
);

export default CheckMeterStop;
